import Swiper from 'swiper/bundle'

export default class ImageSlider {
	constructor() {
		this.sliderContainers = document.querySelectorAll('.image-swiper')
		if (this.sliderContainers.length === 0) return

		this.swiperInstances = []
		this.isDragging = false
		this.#init()
	}

	#init() {
		this.sliderContainers.forEach(sliderContainer => {
			this.#setUpSwiper(sliderContainer)
		})
		this.#observeVisibility()
		requestAnimationFrame(() => this.#applyParallax())
	}

	#observeVisibility() {
		const observer = new IntersectionObserver(
			entries => {
				entries.forEach(entry => {
					const swiper = entry.target._swiperInstance
					if (!swiper) return
					if (entry.isIntersecting) {
						swiper.autoplay.start()
					} else {
						swiper.autoplay.stop()
					}
				})
			},
			{ threshold: 0.1 }
		)

		this.sliderContainers.forEach((container, i) => {
			container._swiperInstance = this.swiperInstances[i]
			observer.observe(container)
		})
	}

	#clamp(v, min, max) {
		return Math.max(min, Math.min(max, v))
	}

	#applyParallax() {
		const viewportCenter = window.innerWidth / 2
		this.swiperInstances.forEach(swiper => {
			swiper.slides.forEach(slide => {
				if (slide.dataset.disableParallax) return

				const rect = slide.getBoundingClientRect()
				const t = this.#clamp((rect.left + rect.width / 2 - viewportCenter) / viewportCenter, -1, 1)
				const img = slide.querySelector('img')
				if (img) img.style.transform = `translateX(${-t * 20}%)`
			})
		})
		requestAnimationFrame(() => this.#applyParallax())
	}

	#setUpSwiper(container) {
		const that = this
		const swiper = new Swiper(container, {
			speed: 750,
			spaceBetween: 16,
			slidesPerView: 1,
			loop: false,
			autoplay: {
				delay: 5000,
				disableOnInteraction: false,
			},

			breakpoints: {
				640: { slidesPerView: 1.25, spaceBetween: 32 },
				768: { slidesPerView: 2, spaceBetween: 32 },
				1024: { slidesPerView: 2, spaceBetween: 32 },
				1280: { slidesPerView: 3, spaceBetween: 32 },
				1435: { slidesPerView: 3, spaceBetween: 32 },
				1690: { slidesPerView: 3, spaceBetween: 32 },
				2000: {
					slidesPerView: 4,
					spaceBetween: 32,
				},
			},
			on: {
				touchStart() {
					that.isDragging = true
				},
				sliderMove() {
					that.isDragging = true
				},
				touchEnd() {
					that.isDragging = false
				},
				transitionEnd() {
					that.isDragging = false
				},
			},
		})

		swiper.autoplay.stop()
		this.swiperInstances.push(swiper)
		return swiper
	}
}
